module.exports = __webpack_public_path__ + "img/raffle-banner.eef87773.jpg";